import Alpine from 'alpinejs';
import KeenSlider from 'keen-slider';

Alpine.data('camps', (adminURL, postType, lang, author) => ({
  items: '',
  by: 'camps',
  slider: null,
  isLoading: false,
  showDefault: true,

  relatedPostsList() {},

  setFilter(e) {
    const by = e.detail.by;
    this.by = by;
    this.fetchPosts();
  },
  fetchPosts() {
    const formData = new FormData();
    formData.append('action', 'fetchCamps');
    formData.append('by', this.by || 'places');

    fetch(adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        this.items = res.posts;
        this.showDefault = false;
      });
  },
}));
